import {KpUserFinancePanelService} from './kp-user-finance-panel.service';
import register from '@kpsys/angularjs-register';

export default register('portaro.features.user.user-finance-panel')
    .service(KpUserFinancePanelService.serviceName, KpUserFinancePanelService)
    .name();